import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../../services/exports/Constants';

export default {
  title: {
    [ORDER_METHODS.DELIVERY]: 'Livraison',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Service en chambre',
      [RoomServiceLocationType.TableService]: 'Service à table',
    },
  },
  form: {
    doorbell_name: {
      placeholder: 'Nom de sonnette (facultatif)',
    },
    company_name: {
      placeholder: "Nom de l'entreprise (facultatif)",
    },
    customer_note: {
      placeholder: 'Instructions de livraison (facultatif)',
    },
    order_instructions: {
      placeholder: 'Entrer les instructions de commande...',
    },
  },
};
